<template>
    <div class="diy-page">
        <page-diy></page-diy>
    </div>
</template>

<script>
    import pageDiy from "@/components/diy/index.vue";

    export default {
        name: "diy",
        components: {
            pageDiy
        },
        data () {
            return {
            }
        },
        created() {
        },
        mounted() {
        }
    }
</script>

<style scoped>
</style>
